<template>
    <div class="lastthreadmsgs">
        <b-card _title="Communications">
            <AgGridVue :style="`height: 280px;width: 100%`" 
                                class="ag-theme-alpine" 
                                :columnDefs="columnDefs" 
                                :rowData="msgs"
                                :defaultColDef="defaultColDef" 
                                :suppressColumnVirtualisation="false" >
            </AgGridVue>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    components: {
        AgGridVue,
    },
    data: function () {
        return {
            msgs: [],
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            columnDefs: [
                { hide: true, field: "id" },
                { headerName: "Unit", field: "unit", width: '90px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Message", field: "message", width: '200px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Thread", field: "thread", width: '150px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] },  },
            ],
        };
    },
    name: "LastThreadMsgs",
    async mounted() {
        this.msgs = await API.lastthreadmsgs( this.section, this.filtro);
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    props: {
        filtro: { type: Array, default: null }
    },
    watch: {
        filtro: {
            handler: async function (val) {
                console.log("filter changed",val)
                this.$nextTick(async () => {
                    this.msgs = await API.lastthreadmsgs( this.section, this.filtro);
                })
            },
            immediate: true
        }
    },
    methods: {
    },
};
</script>

<style scoped>
div.lastthreadmsgs {
    max-height: calc(100vh - 470px);
    overflow-y: auto;
    margin-bottom: 10px;
}
.col-9 {
    text-align: left;
    border-left: 1px solid #ccc;
}
.row.issue {
    border-bottom: 1px solid #ccc;
}
</style>
